import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "../mock/mock";
import Logo from "./Logo";

export default function Header({ onCandidater }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#0a1626]/90 backdrop-blur-md border-b border-white/10 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <Logo onClick={() => scrollTo("hero")} />

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <button
              key={link.to}
              onClick={() => scrollTo(link.to)}
              className="text-sm font-medium text-slate-200 hover:text-[#F5941E] transition-colors duration-200 relative after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 after:bg-[#F5941E] after:transition-all after:duration-300 hover:after:w-full"
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={onCandidater}
            className="hidden sm:inline-flex items-center rounded-full bg-[#F5941E] hover:bg-[#e8850e] text-white font-semibold px-6 py-3 text-sm shadow-lg shadow-orange-900/20 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-orange-900/30"
          >
            Candidater
          </button>
          <button
            className="lg:hidden text-white p-2"
            onClick={() => setOpen((o) => !o)}
            aria-label="Menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 ${
          open ? "max-h-96 mt-3" : "max-h-0"
        }`}
      >
        <nav className="bg-[#0a1626]/95 backdrop-blur-md border-t border-white/10 px-6 py-4 flex flex-col gap-1">
          {NAV_LINKS.map((link) => (
            <button
              key={link.to}
              onClick={() => scrollTo(link.to)}
              className="text-left py-3 text-slate-200 hover:text-[#F5941E] transition-colors border-b border-white/5 last:border-0"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => {
              setOpen(false);
              onCandidater();
            }}
            className="mt-3 rounded-full bg-[#F5941E] hover:bg-[#e8850e] text-white font-semibold px-6 py-3 text-sm"
          >
            Candidater
          </button>
        </nav>
      </div>
    </header>
  );
}
